import StateMachine from "statemachine";

const ModeSwitcher = function ({name, container_id, default_state_name, modes, states}) {
    const switcher = $(container_id);
    const selector = {};
    modes.forEach((mode) => {
        let container = $("<div/>");
        let button = $("<button/>").attr({
            class: `btn switcher_item switcher_item_${mode}`
        });
        let icon = $("<i/>").attr({
            class: `f_mtac-icon-${mode} f_mtac-icon-lg`
        });
        let marker = $("<i/>").attr({
            class: "f_mtac-icon-resource_plus notification-marker"
        });
        container.append(button);
        button.append(icon);
        button.append(marker);
        switcher.append(container);
        selector[mode] = button;
    });
    let enable_state = false;
    let sm = new StateMachine({
        name,
        shared_data: {switcher, selector},
        default_state_name,
        states
    });
    for (let mode in selector) {
        selector[mode].on("click", () => {
            sm.transition[mode]();
        });
    }
    Object.defineProperty(this, "mode", {
        get: () => sm.state.name,
        set: (mode) => {
            sm.transition[mode]();
        }
    });
    Object.defineProperty(this, "enable_state", {
        get: () => enable_state,
        set: (enabled) => {
            enable_state = enabled;
        }
    });
    this.disable = () => {
        modes.forEach((mode) => {
            selector[mode].attr("disabled", true);
        });
        enable_state = false;
    };
    this.enable = () => {
        modes.forEach((mode) => {
            selector[mode].removeAttr("disabled", false);
        });
        enable_state = true;
    };
    this.show_marker = (mode) => {
        if (selector[mode] === undefined) {
            return;
        }
        selector[mode].find(".notification-marker").show();
    };
    this.hide_marker = (mode) => {
        if (selector[mode] === undefined) {
            return;
        }
        selector[mode].find(".notification-marker").hide();
    };
};

export default ModeSwitcher;
